import { useContext } from "react";
import type { LeftMenuContextType } from "../@types/contexts/LeftMenu";
import { LeftMenuContext } from "../contexts/LeftMenuContext";

export const useLeftMenu = (): LeftMenuContextType => {
  const context = useContext(LeftMenuContext);

  if (context === undefined) {
    throw new Error("useLeftMenu must be used within a LeftMenuProvider");
  }

  return context;
};
